export enum Parentage {
  Sire = 'Sire',
  Dam = 'Dam'
}
